export const reConstructionMaterialCharacteristicConstants = {
	GetMaterials: {
		FAILURE : 'GET_CONSTRUCTION_MATERIAL_CHARACTERISTIC_FAILURE',
		REQUEST : 'GET_CONSTRUCTION_MATERIAL_CHARACTERISTIC_REQUEST',
		SUCCESS : 'GET_CONSTRUCTION_MATERIAL_CHARACTERISTIC_SUCCESS'
	},
	UpdateCharacteristics: {
		FAILURE : 'UPDATE_CONSTRUCTION_MATERIAL_CHARACTERISTIC_FAILURE',
		REQUEST : 'UPDATE_CONSTRUCTION_MATERIAL_CHARACTERISTIC_REQUEST',
		SUCCESS : 'UPDATE_CONSTRUCTION_MATERIAL_CHARACTERISTIC_SUCCESS'
	},
	GetFileCharacteristics: {
		FAILURE : 'GET_FILE_CONSTRUCTION_MATERIAL_CHARACTERISTIC_FAILURE',
		REQUEST : 'GET_FILE_CONSTRUCTION_MATERIAL_CHARACTERISTIC_REQUEST',
		SUCCESS : 'GET_FILE_CONSTRUCTION_MATERIAL_CHARACTERISTIC_SUCCESS'
	},
	UpdateFileCharacteristics: {
		FAILURE : 'UPDATE_FILE_CONSTRUCTION_MATERIAL_CHARACTERISTIC_FAILURE',
		REQUEST : 'UPDATE_FILE_CONSTRUCTION_MATERIAL_CHARACTERISTIC_REQUEST',
		SUCCESS : 'UPDATE_FILE_CONSTRUCTION_MATERIAL_CHARACTERISTIC_SUCCESS'
	},
	CLEAR: 'CLEAR_CONSTRUCTION_MATERIAL_CHARACTERISTIC'
}